<div
  *ngFor="let errorMessage of _errorMessages"
  class="p-message  {{ _severityClassStyle }}"
  [innerHTML]="errorMessage"
>
</div>
